import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

import styles from "../../styles/AccountModals.module.css";
import { BASE_URL } from "../../utils/constants";
import Spinner from "../../components/spinner";
import { handleApiError } from "../../utils/handleApiError";

import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import Button from "../../components/button-v1";
import { Checkbox } from "../../components/ui/checkbox";
import AlertDialog from "../../components/alert-dialogue";
import { useParams } from "react-router-dom";
import Input from "../../components/ui/input";
export const AddStaffModal = ({
  isOpen,
  location_id,
  onClose,
  comp_renderer,
  current_render,
}) => {
  const { id } = useParams();
  const modalRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(true);
  const [patients, setPatients] = useState([]);
  const [positions, setPositions] = useState([]);
  const [is_account_admin, setIs_account_admin] = useState(false);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    account_position: "",
    account_level: "User",
    // is_account_admin: false,
    active: true,
  });

  const [checkedPatients, setcheckedPatients] = useState({});

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, onClose]);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const account_id = sessionStorage.getItem("acc_id");
    // const location_id = JSON.parse(sessionStorage.getItem("current_loc")).id;

    const fetchPositions = async () => {
      const url = `${BASE_URL}/accounts/${account_id}/positions/`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    };

    const fetchPatients = async () => {
      const url = `${BASE_URL}/patients/${account_id}/${location_id}/patients/`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
        params: { pagination: "false" }, // full list for the staff patient picker
      });
      return response.data.patients;
    };

    const fetchAllData = async () => {
      try {
        setModalLoading(true); // Set loading before fetching data

        const [patientsData, positionsData] = await Promise.all([
          fetchPatients(),
          fetchPositions(),
        ]);
        setPositions(positionsData);
        setPatients(patientsData);
      } catch (error) {
        handleApiError(error);
      } finally {
        setModalLoading(false);
      }
    };

    fetchAllData();
  }, []);

  const handleCheckBoxChange = (checked) => {
    // const { name, checked } = e.target;
    // setFormData((prev) => ({ ...prev, [name]: checked }));
    setIs_account_admin(checked);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const addStaff = async (finalFormData) => {
    const token = localStorage.getItem("authToken");
    const account_id = sessionStorage.getItem("acc_id");
    const location_id = id;
    const url = `${BASE_URL}/accounts/${account_id}/${location_id}/staff-onboard/`;

    try {
      setLoading(true);
      const response = await axios.post(url, finalFormData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setLoading(false);
      comp_renderer(!current_render);

      onClose();
      toast.success("Staff Onboarded successfully!");
    } catch (error) {
      setLoading(false);
      handleApiError(error);
    }
  };

  const validateForm = (finalFormData) => {
    let errors = [];

    if (!finalFormData.first_name.trim())
      errors.push("First Name is required.");
    if (!finalFormData.email.trim()) errors.push("Email is required.");
    if (!finalFormData.account_position)
      errors.push("Please select staff position.");
    if (!finalFormData.password.trim()) {
      errors.push("Password is required.");
    }

    if (errors.length > 0) {
      toast.error(errors.join("\n"), {
        autoClose: 5000,
        style: {
          whiteSpace: "pre-line",
          textAlign: "left",
        },
      });
      return false;
    }

    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const selectedPatientIds = Object.keys(checkedPatients)
      .filter((key) => checkedPatients[key] === true)
      .map((key) => key);

    const finalFormData = {
      ...formData,
      ...(is_account_admin === true
        ? { account_roles: [1] }
        : { account_roles: [4], assigned_patients: selectedPatientIds }),
      account_position: formData.account_position,
    };

    if (validateForm(finalFormData)) {
      addStaff(finalFormData);
    }
  };

  const handleLocationCheckBoxChange = (name, checked) => {
    // const { name, checked } = e.target;
    setcheckedPatients((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  return (
    <Dialog open={isOpen} setOpen={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add New Staff</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <form
            className={`${styles.comp_wrapper} ${
              loading ? styles.loading : ""
            }`}
          >
            <div className={styles.input_group}>
              <div className={styles.input_field}>
                <label>First Name</label>
                <input
                  type="text"
                  name="first_name"
                  placeholder="First Name"
                  value={formData.first_name}
                  onChange={handleChange}
                />
              </div>

              <div className={styles.input_field}>
                <label>Last Name</label>
                <input
                  type="text"
                  name="last_name"
                  placeholder="Last Name"
                  value={formData.last_name}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className={styles.input_group}>
              <div className={styles.input_field}>
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <div className={styles.input_field}>
                <label>Password</label>
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={formData.password}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className={styles.input_group}>
              <div className={styles.input_field}>
                <label>Phone</label>
                <Input
                  className="no-arrows"
                  type="text"
                  mask={true}
                  maskPattern="(999) 999-9999"
                  name="primary_phone"
                  placeholder="Phone"
                  value={formData.primary_phone}
                  onChange={handleChange}
                />
              </div>

              <div className={styles.input_field}>
                <label>Position</label>
                <select
                  name="account_position"
                  value={formData.account_position}
                  onChange={handleChange}
                >
                  <option value="" disabled>
                    Select Position
                  </option>
                  {positions &&
                    positions.map((position) => (
                      <option key={position.id} value={position.id}>
                        {position.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            <div
              className={`${styles.input_group} ${styles.checkbox_container}`}
            >
              <div className={styles.input_field}>
                <label className={styles.checkbox_wrapper}>
                  <Checkbox
                    checked={is_account_admin}
                    onCheckedChange={(checked) => handleCheckBoxChange(checked)}
                  />
                  Admin
                </label>
              </div>
            </div>

            <div className={styles.assign_item}>
              <h3>Assigned Patients</h3>
              {is_account_admin === false ? (
                <div className={styles.items}>
                  {patients?.map((patient) => (
                    <label key={patient.id}>
                      <Checkbox
                        checked={checkedPatients[patient.id] || false}
                        onCheckedChange={(checked) =>
                          handleLocationCheckBoxChange(patient?.id, checked)
                        }
                      />
                      {patient.first_name} {patient.last_name}
                    </label>
                  ))}
                </div>
              ) : (
                <p>
                  Admins are assigned all patients by default and can create
                  staff.{" "}
                </p>
              )}
            </div>
          </form>
        </DialogBody>
        <DialogFooter>
          <Button onClick={handleSubmit} loading={loading}>
            Add Staff
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export const EditLocStaffModal = ({
  isOpen,
  onClose,
  staff_info,
  location_id,
  comp_renderer,
  current_render,
}) => {
  const { id } = useParams();
  const modalRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [modalLoading, setModalLoading] = useState(true);
  const [patients, setPatients] = useState([]);
  const [positions, setPositions] = useState([]);
  const [is_account_admin, setIs_account_admin] = useState(
    staff_info.account_roles[0]?.name === "Account Admin" ? true : false
  );
  const [formData, setFormData] = useState({
    first_name: staff_info.user.first_name,
    last_name: staff_info.user.last_name,
    email: staff_info.user.email,
    account_position: staff_info.account_position.id,
    primary_phone: staff_info.user.phone_number,
    is_account_admin:
      staff_info.account_roles[0]?.name === "Account Admin" ? true : false,
  });

  const [checkedPatients, setcheckedPatients] = useState({});

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, onClose]);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    const account_id = sessionStorage.getItem("acc_id");
    // const location_id = JSON.parse(sessionStorage.getItem("current_loc")).id;

    const fetchPositions = async () => {
      const url = `${BASE_URL}/accounts/${account_id}/positions/`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    };

    const fetchPatients = async () => {
      const url = `${BASE_URL}/patients/${account_id}/${location_id}/patients/`;
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
        params: { pagination: "false" }, // full list for the staff patient picker
      });
      return response.data.patients;
    };

    const fetchAllData = async () => {
      try {
        setModalLoading(true); // Set loading before fetching data

        const [patientsData, positionsData] = await Promise.all([
          fetchPatients(),
          fetchPositions(),
        ]);
        setPositions(positionsData);
        setPatients(patientsData);
      } catch (error) {
        handleApiError(error);
      } finally {
        setModalLoading(false);
      }
    };

    fetchAllData();
  }, []);

  useEffect(() => {
    if (staff_info?.assigned_patients) {
      const initialcheckedPatients = staff_info.assigned_patients.reduce(
        (acc, patient) => {
          acc[patient.id] = true;
          return acc;
        },
        {}
      );

      setcheckedPatients(initialcheckedPatients);
    }
  }, [staff_info]);

  const handleCheckBoxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({ ...prev, [name]: checked }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const EditStaff = async (finalFormData) => {
    const token = localStorage.getItem("authToken");
    const account_id = sessionStorage.getItem("acc_id");
    const location_id = id;

    let url = null;
    // const url = `${BASE_URL}/accounts/${account_id}/staff/${staff_info.id}/${location_id}/edit/`;
    // if (is_account_admin) {
    //   url = `${BASE_URL}/accounts/${account_id}/staff/${staff_info.id}/edit/`;
    // } else {
    url = `${BASE_URL}/accounts/${account_id}/staff/${staff_info.id}/${location_id}/edit/`;
    // }

    try {
      setLoading(true);
      const response = await axios.patch(url, finalFormData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setLoading(false);
      comp_renderer(!current_render);
      onClose();
      toast.success("Staff Edited successfully.");
    } catch (error) {
      setLoading(false);
      handleApiError(error);
    }
  };

  const validateForm = (finalFormData) => {
    let errors = [];
    const selectedPatientIds = Object.keys(checkedPatients)
      .filter((key) => checkedPatients[key] === true)
      .map((key) => key);

    if (!finalFormData.first_name.trim())
      errors.push("First Name is required.");
    if (!finalFormData.email.trim()) errors.push("Email is required.");
    if (!finalFormData.account_position)
      errors.push("Please select staff position.");
    if (finalFormData.assigned_patients?.length === 0)
      errors.push("Please select atleast one patient.");

    if (errors.length > 0) {
      toast.error(errors.join("\n"), {
        autoClose: 5000,
        style: {
          whiteSpace: "pre-line",
          textAlign: "left",
        },
      });
      return false;
    }

    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const selectedPatientIds = Object.keys(checkedPatients)
      .filter((key) => checkedPatients[key] === true)
      .map((key) => key);

    const finalFormData = {
      ...formData,
      ...(is_account_admin === true
        ? { account_roles: [1] }
        : { assigned_patients: selectedPatientIds, account_roles: [4] }),
      account_position: formData.account_position,
      external_role: null,
    };

    if (validateForm(finalFormData)) {
      EditStaff(finalFormData);
    }
  };

  const handleLocationCheckBoxChange = (e) => {
    const { name, checked } = e.target;
    setcheckedPatients((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} setOpen={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit Staff</DialogTitle>
        </DialogHeader>
        <DialogBody>
          {modalLoading ? (
            <div className="content-center">
              <Spinner />
            </div>
          ) : (
            <form
              className={`${styles.comp_wrapper} ${
                loading ? styles.loading : ""
              }`}
            >
              <div className={styles.input_group}>
                <div className={styles.input_field}>
                  <label>First Name</label>
                  <input
                    type="text"
                    name="first_name"
                    placeholder="First Name"
                    value={formData.first_name}
                    onChange={handleChange}
                  />
                </div>

                <div className={styles.input_field}>
                  <label>Last Name</label>
                  <input
                    type="text"
                    name="last_name"
                    placeholder="Last Name"
                    value={formData.last_name}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className={styles.input_group}>
                <div className={styles.input_field}>
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>

                <div className={styles.input_field}>
                  <label>Phone</label>
                  <Input
                    className="no-arrows"
                    type="text"
                    mask={true}
                    maskPattern="(999) 999-9999"
                    name="primary_phone"
                    placeholder="Phone"
                    value={formData.primary_phone}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className={`${styles.input_group} ${styles.postal_code}`}>
                <div className={styles.input_field}>
                  <label>Position</label>
                  <select
                    name="account_position"
                    value={formData.account_position}
                    onChange={handleChange}
                  >
                    <option value="" disabled>
                      Select position
                    </option>
                    {positions &&
                      positions.map((position) => (
                        <option key={position.id} value={position.id}>
                          {position.name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div
                className={`${styles.input_group} ${styles.checkbox_container}`}
              >
                <div className={styles.input_field}>
                  <label className={styles.checkbox_wrapper}>
                    <Checkbox
                      checked={formData.is_account_admin}
                      onCheckedChange={(checked) => {
                        setFormData((prev) => ({
                          ...prev,
                          is_account_admin: checked,
                        }));
                        setIs_account_admin(checked);
                      }}
                    />
                    Admin
                  </label>
                </div>
              </div>

              <div className={styles.assign_item}>
                <h3>Assigned Patients</h3>
                {is_account_admin === false ? (
                  <div className={styles.items}>
                    {patients.map((patient) => (
                      <label key={patient.id}>
                        <input
                          type="checkbox"
                          name={patient.id}
                          checked={checkedPatients[patient.id] || false}
                          onChange={handleLocationCheckBoxChange}
                        />
                        {patient.first_name} {patient.last_name}
                      </label>
                    ))}
                  </div>
                ) : (
                  <p>
                    Admins are assigned all patients by default and can create
                    staff.{" "}
                  </p>
                )}
              </div>
            </form>
          )}
        </DialogBody>
        <DialogFooter>
          <Button onClick={onClose} variant="ghost">
            Close
          </Button>
          <Button onClick={handleSubmit} loading={loading}>
            Update
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export const DeleteStaff = ({
  isOpen,
  onClose,
  staff_info,
  comp_renderer,
  current_render,
}) => {
  const modalRef = useRef(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, onClose]);

  const inactiveStaff = async () => {
    const token = localStorage.getItem("authToken");
    const account_id = sessionStorage.getItem("acc_id");
    const url = `${BASE_URL}/accounts/${account_id}/staff/${staff_info.id}/edit/`;

    try {
      setLoading(true);
      const response = await axios.patch(
        url,
        { active: false },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLoading(false);
      comp_renderer(!current_render);
      onClose();
      toast.success("Staff Deleted successfully.");
    } catch (error) {
      setLoading(false);
      handleApiError(error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    inactiveStaff();
  };

  if (!isOpen) return null;

  return (
    <AlertDialog
      open={isOpen}
      setOpen={onClose}
      title="Delete Staff"
      description="Are you sure you want to delete this staff?"
    >
      <Button variant="normal" size="default" onClick={onClose}>
        Cancel
      </Button>
      <Button
        loading={loading}
        variant="danger"
        size="default"
        onClick={handleSubmit}
      >
        Delete
      </Button>
    </AlertDialog>
  );
};
